import { motion } from "framer-motion";
import { Stethoscope, MapPin, TrendingUp, Eye, Phone, Star, ArrowRight, Users, Shield, Scale, Calculator } from "lucide-react";

const STATS = [
  { value: "+35%", label: "Clic in piu su Google", icon: TrendingUp },
  { value: "+45%", label: "Traffico al sito web", icon: Eye },
  { value: "2x", label: "Visite in studio", icon: Users },
  { value: "+16%", label: "Crescita ricerche organiche", icon: Shield },
];

const CATEGORIES = [
  {
    title: "Studi Dentistici",
    icon: Stethoscope,
    color: "#4285F4",
    players: [
      { name: "Dr. Andrea Pezzotti", zone: "Siena centro", note: "145 recensioni, implantologia, 20+ anni esperienza" },
      { name: "Dr. Mirco Marrazzo", zone: "Siena centro", note: "5/5 stelle, studio moderno, precisione" },
      { name: "Studio Nuti-Fimiani", zone: "Siena", note: "Endodonzia, protesi, estetica dentale" },
    ],
    pain: "I pazienti hanno paura del dentista. Un Virtual Tour del tuo studio moderno e accogliente elimina l'ansia prima ancora della prima visita."
  },
  {
    title: "Studi Legali",
    icon: Scale,
    color: "#34A853",
    players: [
      { name: "Studi legali centro storico Siena", zone: "Siena", note: "30+ studi, nessuno con Virtual Tour" },
      { name: "Studi associati Firenze", zone: "Firenze", note: "Zona tribunale, altissima concentrazione" },
    ],
    pain: "Il cliente sceglie l'avvocato anche per impressione. Uno studio con Virtual Tour su Google trasmette professionalita e trasparenza."
  },
  {
    title: "Commercialisti e Consulenti",
    icon: Calculator,
    color: "#FBBC04",
    players: [
      { name: "Studi commercialisti Siena/Firenze", zone: "Toscana", note: "Centinaia di studi, mercato vergine per VT" },
    ],
    pain: "Il tuo studio e' bello, organizzato, professionale. Ma su Google sembra identico a tutti gli altri. Il Virtual Tour ti distingue."
  },
];

const WA_MSG = "Ciao Riccardo! Ho uno studio professionale e vorrei il Virtual Tour 360 per distinguermi su Google.";

export default function LandingDentisti() {
  return (
    <div className="min-h-screen bg-[#0c1220] text-white">
      <div className="max-w-4xl mx-auto px-4 py-10">

        {/* Hero */}
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#4285F4]/10 border border-[#4285F4]/30 text-[#4285F4] text-sm font-bold mb-6">
            <Stethoscope className="w-4 h-4" /> STUDI PROFESSIONALI — Dentisti, Avvocati, Commercialisti
          </div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black leading-tight mb-6">
            Il tuo studio e' impeccabile. <br />
            <span className="text-[#4285F4]">Su Google sembra un garage.</span>
          </h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto leading-relaxed">
            I pazienti e i clienti ti cercano su Google prima di chiamarti. Se vedono 2 foto sfocate,
            <strong className="text-white"> vanno dal collega con le foto migliori. Anche se tu sei piu bravo.</strong>
          </p>
        </motion.div>

        {/* Stats */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-12">
          {STATS.map((s, i) => (
            <motion.div key={i} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.1 }}
              className="bg-white/5 border border-white/10 rounded-2xl p-5 text-center">
              <s.icon className="w-5 h-5 text-[#4285F4] mx-auto mb-2" />
              <div className="text-3xl font-black text-white">{s.value}</div>
              <div className="text-xs text-gray-400 mt-1">{s.label}</div>
            </motion.div>
          ))}
        </div>

        {/* Categories */}
        {CATEGORIES.map((cat, ci) => (
          <motion.div key={ci} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.3 + ci * 0.15 }}
            className="mb-8">
            <div className="flex items-center gap-3 mb-3">
              <cat.icon className="w-6 h-6" style={{ color: cat.color }} />
              <h2 className="text-xl font-black">{cat.title}</h2>
            </div>
            <div className="rounded-2xl p-5 mb-3" style={{ backgroundColor: `${cat.color}10`, borderColor: `${cat.color}30`, borderWidth: 1, borderStyle: 'solid' }}>
              <p className="text-gray-300 text-base">{cat.pain}</p>
            </div>
            <div className="grid gap-2">
              {cat.players.map((p, pi) => (
                <div key={pi} className="flex items-center gap-4 bg-white/5 border border-white/10 rounded-xl px-5 py-3">
                  <div className="w-2 h-2 rounded-full flex-shrink-0" style={{ backgroundColor: cat.color }} />
                  <div className="flex-1 min-w-0">
                    <div className="text-white font-bold text-base">{p.name}</div>
                    <div className="text-gray-400 text-xs">{p.note}</div>
                  </div>
                  <div className="flex items-center gap-1.5 text-xs text-gray-500 flex-shrink-0">
                    <MapPin className="w-3 h-3" /> {p.zone}
                  </div>
                </div>
              ))}
            </div>
          </motion.div>
        ))}

        {/* CTA */}
        <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} transition={{ delay: 0.6 }}
          className="bg-gradient-to-r from-[#4285F4]/20 to-[#34A853]/20 border border-[#4285F4]/30 rounded-2xl p-8 text-center mb-12">
          <h2 className="text-2xl font-black mb-2">Virtual Tour da €99 — Deducibile al 100%</h2>
          <p className="text-gray-300 mb-2">Costa meno di una visura catastale. Ma lavora per te 24/7 su Google Maps.</p>
          <p className="text-gray-400 text-sm mb-6">Art. 108 TUIR — Spesa pubblicitaria integralmente deducibile. PayPal 3 rate TAEG 0%.</p>
          <a href={`https://wa.me/+393273839782?text=${encodeURIComponent(WA_MSG)}`}
            className="inline-flex items-center gap-2 bg-[#4285F4] hover:bg-[#3b78de] text-white font-bold px-8 py-4 rounded-full text-lg transition-all hover:scale-105">
            <Phone className="w-5 h-5" /> Scrivimi su WhatsApp
          </a>
          <p className="text-gray-500 text-xs mt-3">Riccardo Rossi — Fotografo Google Certificato dal 2016</p>
        </motion.div>

        {/* Why it works */}
        <div className="bg-white/5 border border-white/10 rounded-2xl p-6 mb-12">
          <h3 className="text-lg font-bold text-white mb-3">Perche conviene al professionista</h3>
          <ul className="space-y-2 text-gray-300 text-base">
            <li className="flex items-start gap-2"><Star className="w-4 h-4 text-[#FBBC04] mt-1 flex-shrink-0" /> <strong className="text-white">Deducibile 100%</strong> come spesa pubblicitaria (art. 108 TUIR)</li>
            <li className="flex items-start gap-2"><Star className="w-4 h-4 text-[#FBBC04] mt-1 flex-shrink-0" /> Paghi <strong className="text-white">€99</strong> — il tuo commercialista te ne scarica il doppio in tasse</li>
            <li className="flex items-start gap-2"><Star className="w-4 h-4 text-[#FBBC04] mt-1 flex-shrink-0" /> Il Virtual Tour resta online <strong className="text-white">per sempre</strong> su Google Maps</li>
            <li className="flex items-start gap-2"><Star className="w-4 h-4 text-[#FBBC04] mt-1 flex-shrink-0" /> <strong className="text-white">Nessun canone mensile.</strong> Paghi una volta, lavora per sempre.</li>
          </ul>
        </div>

        {/* Final CTA */}
        <div className="text-center">
          <a href={`https://wa.me/+393273839782?text=${encodeURIComponent(WA_MSG)}`}
            className="inline-flex items-center gap-2 bg-[#EA4335] hover:bg-[#d33426] text-white font-bold px-8 py-4 rounded-full text-lg transition-all hover:scale-105">
            Distinguiti dai colleghi <ArrowRight className="w-5 h-5" />
          </a>
          <p className="text-gray-600 text-xs mt-4">schedabusiness.it — Fotografo Google Street View Certificato dal 2016</p>
        </div>
      </div>
    </div>
  );
}
